export default {
    'add-new-company': 'Add new company',
    'this-company': 'this company'
}